<!--Nueva tabla-->
<mat-card class="mb-2" *ngFor="let element of currentStages"  [ngStyle]="{'background-color': (element.id == lastCreatedStage?.id && lastCreatedStage?.statusId == Statuses.StageCancelled) ? '#D3D3D3' : '#ffffff'}">
  <div class="row text-start mb-4">
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Etapa:</div> <div class="fw-semibold">{{element.stageNumber}}</div></div>
    </div>
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Alineadores Superiores:</div> 
        <div *ngIf="!element.editMode" class="fw-semibold">{{element.upperAligners}}</div>
        <input *ngIf="element.editMode" type="number" style="max-width: 40px;" min="0" [(ngModel)]="element.upperAligners" />
      </div>
    </div>
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Alineadores Inferiores:</div><div class="fw-semibold" *ngIf="!element.editMode">{{element.lowerAligners}}</div>
        <input *ngIf="element.editMode" type="number" style="max-width: 40px;" min="0" [(ngModel)]="element.lowerAligners" />
      </div>
    </div>
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Alineadores totales:</div>  <div class="fw-semibold">{{element.totalAlignersQuantity}}</div></div>
    </div>
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Frecuencia:</div> <div class="fw-semibold" *ngIf="!element.editMode">{{element.frecuencyDays}}</div>
        <input *ngIf="element.editMode" type="number" style="max-width: 40px;" min="0" [(ngModel)]="element.frecuencyDays" />
     </div>
    </div>
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Inicio de etapa:</div> <div class="fw-semibold" *ngIf="!element.editMode">
        <span *ngIf="element.startDate; else noDateTemplate">{{element.startDate | dynamic: 'date'}}</span>
        <ng-template #noDateTemplate><span class="text-danger">Por Definir</span></ng-template>
      </div>
      <mat-form-field *ngIf="element.editMode" appearance="outline" class="mr-2">
        <mat-label>Inicio de Etapa</mat-label>
        <input matInput [(ngModel)]="element.startDate"
              [matDatepicker]="pickerStarDate"
              name="startDate"
              (dateChange)="setStageDates($event, element)">
        <mat-datepicker-toggle matSuffix [for]="pickerStarDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerStarDate></mat-datepicker>
      </mat-form-field></div>
    </div>

    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Estatus:</div>
        <p class="d-inline p-1 rounded" [ngStyle]="{'background-color': element['statusColor'], 'color': element['statusColor'] != 'transparent' ? '#fff' : '#333'}">
          <span>{{element.statusDescriptionEcommerce}}</span>
        </p></div>
    </div>
    <div class="col-6 col-md-3 mb-2">
      <div><div class="me-1">Dirección de Envío</div>
        <p>
          <span><b>{{element.shipmentCustomerAddress ? element.shipmentCustomerAddress : element.shipmentExceptionAddress}}<mat-icon class="" (click)="onEditCaseStageShippingAddress(element)">edit</mat-icon></b></span>
        </p></div>
    </div>
  </div>
  <mat-card-actions class="mt-2" style="border-top: 1px solid rgb(228, 228, 228);">
    <p *ngIf="element.isManufactured; else actionsTemplate" class="manufacturing-text">En Fabricación</p>
          <ng-template #actionsTemplate>
            <div class="w-100 d-flex flex-wrap">
              <!-- Accept / Refuse aligners quantity  -->
              <button *ngIf="isPendingToApprove(element) && !element.editMode" mat-button class="button secondary-button lh-1 mx-2 my-2 rounded" style="height: fit-content;" (click)="onHandleReviewStage(element)">
                <mat-icon>priority_high</mat-icon> Revisar
              </button>
              <!-- Edit / Confirm Buttons -->
              <button *ngIf="!isPendingToApprove(element) && !element.setup.isPartialSave && (element.id != lastCreatedStage?.id && element.statusId == Statuses.StageCancelled)" mat-button class="button secondary-button rounded lh-1 mx-2 my-2" style="height: fit-content;" (click)="onHandleClickEdit(element)" [hidden]="element.orderStatus > orderStatusToValidateAligners || element.stageNumber != currentStageNumber">
                <ng-container *ngIf="!element.editMode; else editModeTemplate">
                  <mat-icon>edit</mat-icon> Editar
                </ng-container>
                <ng-template #editModeTemplate>
                  <mat-icon>done</mat-icon> Guardar
                </ng-template>
              </button>
              <!-- Close edit button -->
              <button mat-button class="button btn-danger lh-1 rounded mx-2 my-2" [hidden]="!element.editMode" style="height: fit-content;" (click)="onHandleClickClose(element)">
                <mat-icon>close</mat-icon> Cancelar
              </button>
              <!-- Delete button -->
              <button mat-button *ngIf="!element.editModev && checkCaseStageComplete(element)" class="button btn-danger lh-1 rounded mx-2 my-2" style="height: fit-content;" [hidden]="element.stageNumber==1 || case?.currentCaseStageId != element.id || !element.statusIsCancelable" (click)="onHandleClickDelete(element)">
                <mat-icon>block</mat-icon> Cancelar etapa
              </button>
              <!-- Download PDF button -->
              <button mat-button *ngIf="!element.editMode" class="button info-button lh-1 rounded mx-2 my-2" style="height: fit-content;"  [hidden]="element.shippingCompany==null&&element.shippingComments==null&&element.guideNumber==null&&element.guideURL==null" 
                (click)="onHandleShowShippingInfo(element)">
                <mat-icon>
                  place
                </mat-icon>
                Seguimiento de envio
              </button>

              <button mat-button *ngIf="!element.editMode" class="button info-button lh-1 rounded mx-2 my-2" style="height: fit-content;"  [hidden]="element.setupLink==null"
                (click)="goToSetupLink(element)">
                <mat-icon>
                  link
                </mat-icon>
                Setup (Link Doctor)
              </button>

              <button mat-button *ngIf="!element.editMode" class="button info-button lh-1 rounded mx-2 my-2" style="height: fit-content;"  [hidden]="element.setupLinkPx==null"
                (click)="goToSetupLinkPx(element)">
                <mat-icon>
                  link
                </mat-icon>
                Setup (Link Paciente)
              </button>

              <button mat-button *ngIf="!element.editMode && checkCaseStageComplete(element)" class="button info-button lh-1 rounded mx-2 my-2" style="height: fit-content;"
                (click)="goToCaseSetupFiles(element)">
                <mat-icon>
                  file_present
                </mat-icon>
                Archivos del setup
              </button> 

              <button mat-button *ngIf="!checkCaseStageComplete(element)" class="button info-button lh-1 rounded mx-2 my-2 bg-warning" style="height: fit-content;"
              (click)="completeCaseStage(element)">
              <mat-icon>
                edit
              </mat-icon>
              Completar
            </button> 
            <button mat-button *ngIf="element.id == lastCreatedStage?.id && lastCreatedStage?.statusId == Statuses.StageCancelled" class="button info-button lh-1 rounded mx-2 my-2 bg-warning"
              style="height: fit-content;" (click)="onReactivateCaseStage(element.id)">
              <mat-icon>
                autorenew
              </mat-icon>
              Reactivar
            </button>
            <div *ngIf="element.preSetupUsed==true" class="px-3 my-auto text-start" style="width: 300px !important;">
              <p class="fw-semibold">Comentarios</p>
              <div class="small scroll-comments">{{checkCommentsEmptyOrNull(element.generalComments)}}</div>
            </div>
            <div *ngIf="element.preSetupUsed==true && element.importantChangesComments != null && element.importantChangesComments != ''" class="px-3 my-auto text-start"  style="width: 300px!important;">
              <p class="fw-semibold">Cambios importantes</p>
              <div class="small scroll-comments">{{checkCommentsEmptyOrNull(element.importantChangesComments)}}</div>
            </div>
          </div>                  
          </ng-template>
  </mat-card-actions>
</mat-card>

<div class="mt-4">
  <button mat-button class="button info-button" (click)="onHandleClickAdd()" [disabled]="isCaseExpired"> Agregar Etapa <mat-icon>add</mat-icon></button>
  <p class="text-danger" *ngIf="isCaseExpired">No es posible agregar nuevas etapas debido a que el caso se encuentra expirado</p>
</div>


<app-dialog #chooseSetupTypeDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onSelectSetupType.bind(this)" [cancelCallBackFunction]="onCancelChooseSetup.bind(this)" confirmButtonText="Confirmar" confirmButtonIcon="" cancelButtonClass="button info-button" confirmButtonClass="button secondary-button" width="90%">
  <div>
    <div class="w-100 w-sm-50 mx-auto d-flex flex-column justify-content-center gap-5 p-4" *ngIf="!setupType">
      <h2 class="col text-center">Estas a punto de crear una nueva etapa en el caso, elige una de las opciones disponibles:</h2>
      <mat-radio-group aria-label="Seleciona una opción" [(ngModel)]="setupType">
        <div [ngClass]="size930 ? 'd-flex flex-column gap-3': 'd-flex justify-content-center gap-5'" class="">
          <div class="setup-option-container p-4 card col" *ngFor="let item of setupOptions" [ngClass]="{'active': setupType == item.value}" (click)="setupType = item.value; setupValidationsDone = true;">
            <div class="row w-100">
              <mat-radio-button class="col col-1 align-self-center" [value]="item.value" [checked]="item.value == setupType"></mat-radio-button>
              <h3 class="col col-10 my-0 text-start">{{item.label}}</h3>
            </div>
            <p class="row w-100 text-start">{{item.description}}</p>
          </div>
        </div>
      </mat-radio-group>
    </div>

    <!-- Setup options -->
    <div *ngIf="setupType" class="h-100 d-flex justify-content-center">
      <button mat-icon-button matTooltip="Volver" (click)="setupType = 0" class="return-icon"><mat-icon>chevron_left</mat-icon></button>
      <!-- NEW SETUP -->
      <div *ngIf="setupType == 1">
        <app-client-crud-setup [stageNumber]="currentNewStageId" [isPartialSave]="isPartialSave" [isCaseFileCompleted]="isCaseFileCompleted" *ngIf="setupValidationsDone"></app-client-crud-setup>
      </div>

      <div *ngIf="setupType == 2" class="mx-auto d-flex flex-column">
        <h3 class="text-center">Indica en los comentarios el número de alineadores y de qué arcadas deseas reimprimir</h3>
        <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
        <div class="row text-start m-0 p-0 align-items">
          <div class="w-100">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Comentarios</mat-label>
              <textarea matInput placeholder="Comentarios" [(ngModel)]="generalComments"  style="height: 120px;"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-dialog>


<app-dialog #approvalDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" width="70%">
  <div class="text-start">
    <div *ngIf="!isShowApprovalMessage && shippingAddressSelectionProcess == 1" class="w-75 mx-auto d-flex flex-column justify-content-center gap-2 p-4">
      <h2 class="fw-semibold text-center mb-4">Revisar propuesta</h2>
      <h6>Alineadores necesarios para esta etapa</h6>
      <div class="d-flex">
        <p class="me-2">Alineadores superiores: <strong>{{stageToApprove?.upperAligners}}</strong></p>
        <p>Alineadores inferiores: <strong>{{stageToApprove?.lowerAligners}}</strong></p>
      </div>
      <hr>
      <h6>Alineadores fabricados del caso</h6>
      <div class="d-flex">
        <p class="me-2">Superiores: <strong>{{fabricatedUpperAligners}} de {{case?.upperAligners}}</strong></p>
        <p>Inferiores: <strong>{{fabricatedLowerAligners}} de {{case?.lowerAligners}}</strong></p>
      </div>
      <hr>
      <h6>Mecánicas Setup</h6>
      <mat-form-field class="w-100" appearance="outline">
        <textarea disabled matInput placeholder="Descripción del tipo de cliente" name="description" id="description" style="height: 120px;">{{stageToApprove?.setupMechanics}}</textarea>
      </mat-form-field>
      <mat-checkbox style="width: fit-content;" class="col text-start"  (change)="onCheckboxChange($event.checked)"><span style="white-space:normal;" >Estoy de acuerdo con las mecánicas sugeridas por Aliwell</span></mat-checkbox>

      <div class="d-flex justify-content-between">
        <button mat-button class="button btn btn-danger lh-1 p-2 rounded mb-2"  appDebounceClick (debounceClick)="onCancelStage()" [debounceTime]="700" [disabled]="!disableAcceptSetup && hasSetupMechanics">Cancelar etapa <mat-icon>close</mat-icon></button>
        <button mat-button class="button btn-outline-primary lh-1 p-2 rounded mb-2"  appDebounceClick (debounceClick)="onSuggestAlignersByAliwell()" [debounceTime]="700" [disabled]="!disableAcceptSetup && hasSetupMechanics">Solicitar cambios <mat-icon>cached</mat-icon></button>
        <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2"  appDebounceClick (debounceClick)="onRefuseSetup()" [debounceTime]="700" [disabled]="disableAcceptSetup" style="font-size: .8rem">Aprobar con otra cantidad de alineadores<mat-icon>edit</mat-icon></button>
        <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2" (click)="goToShippingAddressSelection(false)" [disabled]="disableAcceptSetup">Autorizar propuesta <mat-icon>check</mat-icon></button>
      </div>
      <p>Nota: Antes de realizar cualquier acción revisa tu etapa y la cantidad de alineadores superiores e inferiores para la misma.</p>
    </div>

    <div *ngIf="isShowApprovalMessage && shippingAddressSelectionProcess == 1" class="w-50 mx-auto d-flex flex-column justify-content-center gap-2 p-4">  
      <h2 class="col text-center">Sugiere una cantidad de alineadores para esta etapa</h2>
      <mat-card class="card-general">
        <mat-card-title>Alineadores de la etapa</mat-card-title>
        <mat-card-content class="d-flex flex-column gap-4 w-100">
          <form #alignersForm="ngForm">
            <div class="row">
              <div class="col-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Alineadores Superiores</mat-label>
                  <input matInput type="number" min="0" required ngModel name="upperAligners" placeholder="Número de alineadores" [disabled]="disableEditAligners">
                  <mat-error *ngIf="alignersForm.form.hasError('required', ['upperAligners'])">Completa este campo</mat-error>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Alineadores Inferiores</mat-label>
                  <input matInput type="number" min="0" required ngModel name="lowerAligners" placeholder="Número de alineadores" [disabled]="disableEditAligners">
                  <mat-error *ngIf="alignersForm.form.hasError('required', ['lowerAligners'])">Completa este campo</mat-error>
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Comentarios</mat-label>
                  <textarea matInput placeholder="Comentarios" name="comments" id="comments" ngModel style="height: 120px;" [disabled]="disableEditAligners"></textarea>
                </mat-form-field>
              </div>
              <ng-container *ngIf="disableEditAligners">
                <div class="col-12" >
                    <p><b>Para esta etapa se deben fabricar todos los alineadores restantes</b></p>
                  </div>
              </ng-container>
            </div>
          </form>
        </mat-card-content>
      </mat-card>

      <div class="d-flex justify-content-center gap-4">
        <button mat-button class="btn btn-secondary" (click)="onBackToMainPage()"><mat-icon>chevron_left</mat-icon>Volver</button>
        <button mat-button class="btn btn-secondary" (click)="onUpdateAligners()" [disabled]="disableEditAligners">Enviar<mat-icon>send</mat-icon></button>
      </div>
    </div>

    <!--Address containers-->
    <div *ngIf="shippingAddressSelectionProcess == 2" class=" w-75 m-auto">
      <h2 class="fw-semibold text-center mb-4">Direcciones de Envío</h2>
      <div class="my-2" *ngIf="selectedAddress != null;else addAddressTemplate">
        <mat-card appearance="outlined" class="card-shipping-address">
          <mat-card-content class="d-flex flex-wrap justify-content-between">
            <div>
              <h6 class="fw-semibold d-flex"><div *ngIf="!selectedAddress.isAddressException">Enviar a <sup>&nbsp;</sup> </div> {{selectedAddress.type}}</h6>
              <p>{{selectedAddress.fullAddress}}</p>
            </div>
            <div class="d-flex mt-auto">
              <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2 mt-auto" (click)="onShippingAddressChange()">Cambiar</button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <ng-template #addAddressTemplate>
        <p>Para avanzar es necesario seleccionar una dirección de envío</p>
        <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2 ms-auto" (click)="onGoToCustomerProfileConfirmation()">Agregar dirección <mat-icon>add</mat-icon></button>
      </ng-template>
      <p>Nota: Es necesario elegir una dirección de envío para aprobar el caso. Esta dirección podrá modificarse solamente dentro de las siguentes {{maxHoursToUpdateDate}} horas.</p>
      <div class="d-flex my-4">
        <img class="w-50 mx-auto img-fluid" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
      </div>
      <div class="d-flex justify-content-center gap-4 my-4">
        <button mat-button class="btn btn-secondary" (click)="onCancelAddressAssign()">Cancelar</button>
        <button mat-button class="btn secondary-button text-white" (click)="onConfirmSetup()" *ngIf="selectedAddress != null">Confirmar <mat-icon>send</mat-icon></button>
      </div>
    </div>
    <div *ngIf="shippingAddressSelectionProcess == 3" class="w-75 m-auto d-flex flex-column">
      <h2 class="fw-semibold text-center mb-4">Direcciones de Envío</h2>
      <div class="my-2 text-start">
        <mat-radio-group [value]="selectedAddress" (change)="onSelectionChange($event)">
          <div *ngFor="let address of addressList">
            <mat-card appearance="outlined" class="card-shipping-address mb-3">
              <mat-card-content class="d-flex flex-wrap justify-content-between">
                <div class="d-flex">
                  <div class="d-flex my-auto">
                    <mat-radio-button class="my-auto" [checked]="address.fullAddress == selectedAddress.fullAddress" [value]="address"></mat-radio-button>
                  </div>
                  <div class="text-start">
                    <h6 class="fw-semibold d-flex"><div *ngIf="!address.isAddressException">Enviar a <sup>&nbsp;</sup></div>  {{address.type}} <div class="badge badge-pickup-primary" *ngIf="address.isAddressException">Recolección</div></h6>
                    <p>{{address.fullAddress}}</p>
                  </div>
                </div>
                
                <div class="d-flex mt-auto">
                  <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2 mt-auto" (click)="onGoToCustomerProfileConfirmation()" *ngIf="!address.isAddressException">Editar</button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-radio-group>
      </div>
      <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2 ms-auto" (click)="onGoToCustomerProfileConfirmation()">Agregar dirección <mat-icon>add</mat-icon></button>
      <div class="d-flex justify-content-center gap-4 my-4">
        <button mat-button class="btn btn-secondary" (click)="onCancelAddressSelection2()">Cancelar</button>
        <button mat-button class="btn secondary-button text-white" (click)="goToShippingAddressSelection(this.isApproveWithChanges)">Seleccionar <mat-icon>check</mat-icon></button>
      </div>
    </div>
    <div *ngIf="shippingAddressSelectionProcess == 4" class="w-75 m-auto d-flex flex-column">
      <h2 class="text-center mb-4">Serás redirigido a tu perfil para realizar los cambios de dirección y deberás reiniciar el proceso de aprobación</h2>
      <h2 class="fw-semibold text-center mb-4">¿Deseas confirmar?</h2>
      <div class="d-flex my-4">
        <img class="w-50 mx-auto img-fluid" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
      </div>
      <div class="d-flex justify-content-center gap-4 my-4">
        <button mat-button class="btn btn-secondary" (click)="onCancelAddressEdition()">Cancelar</button>
        <button mat-button class="btn btn-danger text-white" (click)="onGoToCustomerProfile()">Continuar <mat-icon>arrow_forward</mat-icon></button>
      </div>
    </div>
  </div>
</app-dialog>

<!-- Delete CaseStage Dialog -->
<app-dialog #deleteDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onDeleteEntity.bind(this)" confirmButtonText="Cancelar etapa" confirmButtonIcon="block" confirmButtonClass="button danger-button" height="90%" width="90%">
  <div>
    <div class="w-100 w-sm-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center"><strong>Estas a punto de cancelar</strong> la etapa #<strong>{{caseStageSelected?.stageNumber ?? "Etapa seleccionada"}}</strong>, toda la información relacionada con esta no será visible <strong>¿Estas seguro de realizar esta acción?</strong></h2>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
    </div>
  </div>
</app-dialog>

<app-dialog #showShippingInfoDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true"  confirmButtonText="Cerrar" confirmButtonClass="button info-button" height="90%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center">Datos de envío</h2>
      <div class="row">
        <div class="col-6">
          <mat-form-field class="w-100" appearance="outline" floatLabel="always">
            <mat-label>Paquetería</mat-label>
            <input matInput placeholder="Paquetería" name="shippingCompany" id="shippingCompany" value={{caseStageSelected?.shippingCompany}} [disabled]="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="outline" floatLabel="always">
            <mat-label>Número de guía</mat-label>
            <input matInput placeholder="Número de guía" name="guideNumber" id="guideNumber" value={{caseStageSelected?.guideNumber}}  [disabled]="true">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <mat-form-field class="w-100" appearance="outline" floatLabel="always">
            <mat-label>URL de guía</mat-label>
            <input matInput placeholder="URL de guía" name="guideURL" id="guideURL" value={{caseStageSelected?.guideURL}}  [disabled]="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="outline" floatLabel="always">
            <mat-label>Comentarios de envío</mat-label>
            <textarea matInput placeholder="Comentarios de envío" name="shippingComments" id="shippingComments"  value={{caseStageSelected?.shippingComments}} [disabled]="true"> </textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</app-dialog>

<app-dialog #deleteStageDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onDeleteCaseStage.bind(this)" confirmButtonText="Eliminar" confirmButtonIcon="block" confirmButtonClass="button danger-button" height="90%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <div *ngIf="stageToApprove?.stageNumber == 1;else firstStageTemplate">
        <h2 class="col text-center"><strong>Estás a punto de eliminar</strong> la etapa #<strong>{{stageToApprove?.stageNumber ?? "Etapa seleccionada"}}</strong>, Al ser la etapa #1 toda la información del paciente incluyendo la prescripción se perderá y no se puede deshacer este cambio. <strong>¿Estás seguro que deseas eliminar ésta etapa? </strong></h2>
      </div>
      <ng-template #firstStageTemplate>
        <h2 class="col text-center"><strong>Estás a punto de cancelar</strong> la etapa #<strong>{{stageToApprove?.stageNumber ?? "Etapa seleccionada"}}</strong>, La información de la prescripción se perderá y no se puede deshacer este cambio. <strong>¿Estás seguro que deseas cancelar ésta etapa? </strong></h2>
      </ng-template>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
    </div>
  </div>
</app-dialog>

<app-dialog #suggestAlignersByAliwellDialog [enableCloseDialogButton]="true" cancelButtonText="Volver" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onAddComments.bind(this)" confirmButtonText="Enviar" confirmButtonClass="btn btn-secondary" height="90%" width="90%">
  <div class="text-start">
    <div class="w-75 mx-auto d-flex flex-column p-2">
      <h2 class="col text-center">Solicitar cambios y/o correciones al setup</h2>
      <mat-radio-group class="w-100" (ngModelChange)="onSetupCorrectionSelectionChange()"  [(ngModel)]="selectedSetupCorrection">
        <div *ngFor="let option of setupCorrectionsOptions;let i = index" >
          <mat-card class="setup-change-option-card w-100 h-100 mt-2 p-2" >
            <mat-radio-button [value]="option.value" [checked]="option.value == selectedSetupCorrection">
              <h4>{{option.label}}</h4>
            </mat-radio-button>
            <mat-card-content class="d-flex flex-column w-100 h-100" >
              <div class="d- flex" *ngIf="option.value == 3">
                <mat-icon style="color: #0D565E;">info</mat-icon><b>Importante: </b> No es posible conseguir el mismo resultado con menos alineadores.
              </div>
              <mat-form-field class="w-100 h-100 p-0 m-0 setup-textarea" appearance="outline" color="primary">
                <textarea matInput [disabled]="option.value != selectedSetupCorrection" placeholder={{option.description}} [(ngModel)]="correctionValues[i]"></textarea>
              </mat-form-field>
            </mat-card-content>
          </mat-card>
        </div>
       
      </mat-radio-group>
    </div>
  </div>
</app-dialog>


<app-dialog #updateCaseStageAddressDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" width="70%">
  <div class="text-start">
     <!--Address containers-->
     <div *ngIf="shippingAddressSelectionProcess == 2" class=" w-75 m-auto">
      <h2 class="fw-semibold text-center mb-4">Direcciones de Envío</h2>
      <div class="my-2">
        <mat-card appearance="outlined" class="card-shipping-address">
          <mat-card-content class="d-flex flex-wrap justify-content-between">
            <div class="text-start">
              <h6 class="fw-semibold d-flex"><div *ngIf="selectedAddress.isAddressException">Enviar a <sup>&nbsp;</sup></div> {{selectedAddress.type}}</h6>
              <p>{{selectedAddress.fullAddress}}</p>
            </div>
            <div class="d-flex mt-auto">
              <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2 mt-auto" (click)="onShippingAddressChange()">Cambiar</button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <p>Nota: Es necesario elegir una dirección de envío para aprobar el caso. Esta dirección podrá modificarse solamente dentro de las siguentes {{maxHoursToUpdateDate}} horas.</p>
      <div class="d-flex my-4">
        <img class="w-50 mx-auto img-fluid" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
      </div>
      <div class="d-flex justify-content-center gap-4 my-4">
        <button mat-button class="btn btn-secondary" (click)="onCancelAddressSelectionUpdate()">Cancelar</button>
        <button mat-button class="btn secondary-button text-white" (click)="onUpdateShippingAddress()">Confirmar <mat-icon>send</mat-icon></button>
      </div>
    </div>
    <div *ngIf="shippingAddressSelectionProcess == 3" class="w-75 m-auto d-flex flex-column">
      <h2 class="fw-semibold text-center mb-4">Direcciones de Envío</h2>
      <div class="my-2">
        <mat-radio-group [(ngModel)] = "selectedAddress">
          <div *ngFor="let address of addressList">
            <mat-card appearance="outlined" class="card-shipping-address mb-3">
              <mat-card-content class="d-flex flex-wrap justify-content-between">
                <div class="d-flex">
                  <div class="d-flex my-auto">
                    <mat-radio-button value="auto" class="my-auto" [checked]="address.isDefault" [value]="address"></mat-radio-button>
                  </div>
                  <div>
                    <h6 class="fw-semibold d-flex"><div *ngIf="!address.isAddressException">Enviar a <sup>&nbsp;</sup></div>  {{address.type}} <div class="badge badge-pickup-primary" *ngIf="address.isAddressException">Recolección</div></h6>
                    <p>{{address.fullAddress}}</p>
                  </div>
                </div>
                
                <div class="d-flex mt-auto">
                  <button mat-button class="button secondary-button lh-1 p-2 rounded mb-2 mt-auto" (click)="onGoToCustomerProfileConfirmation()" *ngIf="!address.isAddressException">Editar</button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-radio-group>
      </div>
      <button mat-button class="button btn btn-bg-primary lh-1 p-2 rounded mb-2 ms-auto">Agregar dirección <mat-icon>add</mat-icon></button>
      <div class="d-flex justify-content-center gap-4 my-4">
        <button mat-button class="btn btn-secondary" (click)="onCancelAddressSelection2()">Cancelar</button>
        <button mat-button class="btn secondary-button text-white" (click)="goToShippingAddressSelection(this.isApproveWithChanges)">Seleccionar <mat-icon>check</mat-icon></button>
      </div>
    </div>
    <div *ngIf="shippingAddressSelectionProcess == 4" class="w-75 m-auto d-flex flex-column">
      <h2 class="text-center mb-4">Serás redirigido a tu perfil para realizar los cambios de dirección y deberás reiniciar el proceso de aprobación</h2>
      <h2 class="fw-semibold text-center mb-4">¿Deseas confirmar?</h2>
      <div class="d-flex my-4">
        <img class="w-50 mx-auto img-fluid" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw_notify_danger.svg" alt="Notificación imagen danger">
      </div>
      <div class="d-flex justify-content-center gap-4 my-4">
        <button mat-button class="btn btn-secondary" (click)="onCancelAddressEdition()">Cancelar</button>
        <button mat-button class="btn btn-danger text-white" (click)="onGoToCustomerProfile()">Continuar <mat-icon>arrow_forward</mat-icon></button>
      </div>
    </div>
  </div>
</app-dialog>

